import _taggedTemplateLiteral from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        :host {\n          display: block;\n          opacity: 1;\n        }\n        ::slotted(.hidden) {\n          display: none !important;\n        }\n    \n        :host ::slotted(.hidden) {\n          display: none !important;\n        }\n        #bar {\n          display: -ms-flexbox;\n          display: -webkit-flex;\n          display: flex;\n          -ms-flex-direction: row;\n          -webkit-flex-direction: row;\n          flex-direction: row;\n        }\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      <wired-item role=\"tab\" .value=\"", "\" .selected=\"", "\" ?aria-selected=\"", "\"\n        @click=\"", "\">", "</wired-item>\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    <div id=\"bar\">\n      ", "\n    </div>\n    <div>\n      <slot @slotchange=\"", "\"></slot>\n    </div>\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { LitElement, customElement, property, css, html, query } from 'lit-element';
import { BaseCSS } from 'wired-lib/lib/wired-base';

var WiredTabs = /*#__PURE__*/function (_LitElement) {
  _inherits(WiredTabs, _LitElement);

  var _super = _createSuper(WiredTabs);

  function WiredTabs() {
    var _this;

    _classCallCheck(this, WiredTabs);

    _this = _super.apply(this, arguments);
    _this.pages = [];
    _this.pageMap = new Map();
    return _this;
  }

  _createClass(WiredTabs, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return html(_templateObject(), this.pages.map(function (p) {
        return html(_templateObject2(), p.name, p.name === _this2.selected, p.name === _this2.selected, function () {
          return _this2.selected = p.name;
        }, p.label || p.name);
      }), this.mapPages);
    }
  }, {
    key: "mapPages",
    value: function mapPages() {
      var _this3 = this;

      this.pages = [];
      this.pageMap.clear();

      if (this.slotElement) {
        var assigned = this.slotElement.assignedNodes();

        if (assigned && assigned.length) {
          for (var i = 0; i < assigned.length; i++) {
            var n = assigned[i];

            if (n.nodeType === Node.ELEMENT_NODE && n.tagName.toLowerCase() === 'wired-tab') {
              (function () {
                var e = n;

                _this3.pages.push(e);

                var name = e.getAttribute('name') || '';

                if (name) {
                  name.trim().split(' ').forEach(function (nameSegment) {
                    if (nameSegment) {
                      _this3.pageMap.set(nameSegment, e);
                    }
                  });
                }
              })();
            }
          }

          if (!this.selected) {
            if (this.pages.length) {
              this.selected = this.pages[0].name;
            }
          }

          this.requestUpdate();
        }
      }
    }
  }, {
    key: "firstUpdated",
    value: function firstUpdated() {
      var _this4 = this;

      this.mapPages();
      this.tabIndex = +(this.getAttribute('tabindex') || 0);
      this.addEventListener('keydown', function (event) {
        switch (event.keyCode) {
          case 37:
          case 38:
            event.preventDefault();

            _this4.selectPrevious();

            break;

          case 39:
          case 40:
            event.preventDefault();

            _this4.selectNext();

            break;
        }
      });
    }
  }, {
    key: "updated",
    value: function updated() {
      var _this5 = this;

      var newPage = this.getElement();

      for (var i = 0; i < this.pages.length; i++) {
        var p = this.pages[i];

        if (p === newPage) {
          p.classList.remove('hidden');
        } else {
          p.classList.add('hidden');
        }
      }

      this.current = newPage || undefined;

      if (this.current && this.current.wiredRender) {
        requestAnimationFrame(function () {
          return requestAnimationFrame(function () {
            return _this5.current.wiredRender();
          });
        });
      }
    }
  }, {
    key: "getElement",
    value: function getElement() {
      var e = undefined;

      if (this.selected) {
        e = this.pageMap.get(this.selected);
      }

      if (!e) {
        e = this.pages[0];
      }

      return e || null;
    }
  }, {
    key: "selectPrevious",
    value: function selectPrevious() {
      var list = this.pages;

      if (list.length) {
        var index = -1;

        for (var i = 0; i < list.length; i++) {
          if (list[i] === this.current) {
            index = i;
            break;
          }
        }

        if (index < 0) {
          index = 0;
        } else if (index === 0) {
          index = list.length - 1;
        } else {
          index--;
        }

        this.selected = list[index].name || '';
      }
    }
  }, {
    key: "selectNext",
    value: function selectNext() {
      var list = this.pages;

      if (list.length) {
        var index = -1;

        for (var i = 0; i < list.length; i++) {
          if (list[i] === this.current) {
            index = i;
            break;
          }
        }

        if (index < 0) {
          index = 0;
        } else if (index >= list.length - 1) {
          index = 0;
        } else {
          index++;
        }

        this.selected = list[index].name || '';
      }
    }
  }], [{
    key: "styles",
    get: function get() {
      return [BaseCSS, css(_templateObject3())];
    }
  }]);

  return WiredTabs;
}(LitElement);

__decorate([property({
  type: String
}), __metadata("design:type", String)], WiredTabs.prototype, "selected", void 0);

__decorate([query('slot'), __metadata("design:type", HTMLSlotElement)], WiredTabs.prototype, "slotElement", void 0);

WiredTabs = __decorate([customElement('wired-tabs')], WiredTabs);
export { WiredTabs };